import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { AuthStateService } from '../core/auth/auth-state.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.css'],
})
export class AppMenuComponent implements OnInit {
    model: any[] = [];

    partnerInfo!: String;

    constructor(
        public layoutService: LayoutService,
        private authStateService: AuthStateService,
        private router: Router
    ) {}

    ngOnInit() {
        this.model = [
            {
                items: [
                    // {
                    //     label: 'Partners', icon: 'pi pi-id-card',
                    //     routerLink: ['/home/partners'],
                    //     permission: 'manage_partners'
                    // },
                    {
                        label: 'Involuntary Retrenchment',
                        icon: 'bx bx-user-x',
                        routerLink: ['/home/search'],
                        permission: 'manage_customers',
                    },
                    {
                        label: 'Scholars Insurance',
                        icon: 'bx bx-book-open',
                        routerLink: ['/home/search-scholars-insurance'],
                        permission: 'manage_customers',
                    },
                    {
                        label: 'Personal Road Accident Cover',
                        icon: 'bx bx-accessibility',
                        routerLink: ['/home/personal-accident-search'],
                        permission: 'manage_customers',
                    },
                    {
                        label: 'Reports',
                        icon: 'bx bx-bar-chart-alt-2',
                        routerLink: ['/home/reports'],
                        permission: 'manage_customers',
                    },
                    // {
                    //     label: 'Reports', icon: 'pi pi-chart-line',
                    //     routerLink: ['/home/reports'],
                    //     permission: 'manage_customers'
                    //
                    // },
                    // {
                    //     label: 'Users', icon: 'pi pi-users',
                    //     routerLink: ['/home/users'],
                    //     permission: 'manage_users'
                    // },
                ],
            },
        ];
        this.partnerInfo = this.getUserPartnerAndBranch();
    }

    getUserPartnerAndBranch(): string {
        return this.authStateService.getAuthTokenInfo().partner &&
            this.authStateService.getAuthTokenInfo().partner_branch
            ? this.authStateService.getAuthTokenInfo().partner +
                  '  |  ' +
                  this.authStateService.getAuthTokenInfo().partner_branch
            : '-- | --';
    }

    hasPermission(permission: string): boolean {
        return this.authStateService.checkUserPermission(permission);
    }
}
